import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import Explore from "../pages/Explore";
import axios from "axios";
import { API_URL } from "../actions/auth";

// Import all 65 images statically
import img1 from "../img/bgsimg (1).jpeg";
import img2 from "../img/bgsimg (2).jpeg";
import img3 from "../img/bgsimg (3).jpeg";
import img4 from "../img/bgsimg (4).jpeg";
import img5 from "../img/bgsimg (5).jpeg";
import img6 from "../img/bgsimg (6).jpeg";
import img7 from "../img/bgsimg (7).jpeg";
import img8 from "../img/bgsimg (8).jpeg";
import img9 from "../img/bgsimg (9).jpeg";
import img10 from "../img/bgsimg (10).jpeg";
import img11 from "../img/bgsimg (11).jpeg";
import img12 from "../img/bgsimg (12).jpeg";
import img13 from "../img/bgsimg (13).jpeg";
import img14 from "../img/bgsimg (14).jpeg";
import img15 from "../img/bgsimg (15).jpeg";
import img16 from "../img/bgsimg (16).jpeg";
import img17 from "../img/bgsimg (17).jpeg";
import img18 from "../img/bgsimg (18).jpeg";
import img19 from "../img/bgsimg (19).jpeg";
import img20 from "../img/bgsimg (20).jpeg";
import img21 from "../img/bgsimg (21).jpeg";
import img22 from "../img/bgsimg (22).jpeg";
import img23 from "../img/bgsimg (23).jpeg";
import img24 from "../img/bgsimg (24).jpeg";
import img25 from "../img/bgsimg (25).jpeg";
import img26 from "../img/bgsimg (26).jpeg";
import img27 from "../img/bgsimg (27).jpeg";
import img28 from "../img/bgsimg (28).jpeg";
import img29 from "../img/bgsimg (29).jpeg";
import img30 from "../img/bgsimg (30).jpeg";
import img31 from "../img/bgsimg (31).jpeg";
import img32 from "../img/bgsimg (32).jpeg";
import img33 from "../img/bgsimg (33).jpeg";
import img34 from "../img/bgsimg (34).jpeg";
import img35 from "../img/bgsimg (35).jpeg";
import img36 from "../img/bgsimg (36).jpeg";
import img37 from "../img/bgsimg (37).jpeg";
import img38 from "../img/bgsimg (38).jpeg";
import img39 from "../img/bgsimg (39).jpeg";
import img40 from "../img/bgsimg (40).jpeg";
import img41 from "../img/bgsimg (41).jpeg";
import img42 from "../img/bgsimg (42).jpeg";
import img43 from "../img/bgsimg (43).jpeg";
import img44 from "../img/bgsimg (44).jpeg";
import img45 from "../img/bgsimg (45).jpeg";
import img46 from "../img/bgsimg (46).jpeg";
import img47 from "../img/bgsimg (47).jpeg";
import img48 from "../img/bgsimg (48).jpeg";
import img49 from "../img/bgsimg (49).jpeg";
import img50 from "../img/bgsimg (50).jpeg";
import img51 from "../img/bgsimg (51).jpeg";
import img52 from "../img/bgsimg (52).jpeg";
import img53 from "../img/bgsimg (53).jpeg";
import img54 from "../img/bgsimg (54).jpeg";
import img55 from "../img/bgsimg (55).jpeg";
import img56 from "../img/bgsimg (56).jpeg";
import img57 from "../img/bgsimg (57).jpeg";
import img58 from "../img/bgsimg (58).jpeg";
import img59 from "../img/bgsimg (59).jpeg";
import img60 from "../img/bgsimg (60).jpeg";
import img61 from "../img/bgsimg (61).jpeg";
import img62 from "../img/bgsimg (62).jpeg";
import img63 from "../img/bgsimg (63).jpeg";
import img64 from "../img/bgsimg (64).jpeg";
import img65 from "../img/bgsimg (65).jpeg";

// Create an array of imported images
const images = [
  { image: img1, title: " 1" },
  { image: img2, title: " 2" },
  { image: img3, title: " 3" },
  { image: img4, title: " 4" },
  { image: img5, title: " 5" },
  { image: img6, title: " 6" },
  { image: img7, title: " 7" },
  { image: img8, title: " 8" },
  { image: img9, title: " 9" },
  { image: img10, title: " 10" },
  { image: img11, title: " 11" },
  { image: img12, title: " 12" },
  { image: img13, title: " 13" },
  { image: img14, title: " 14" },
  { image: img15, title: " 15" },
  { image: img16, title: " 16" },
  { image: img17, title: " 17" },
  { image: img18, title: " 18" },
  { image: img19, title: " 19" },
  { image: img20, title: " 20" },
  { image: img21, title: " 21" },
  { image: img22, title: " 22" },
  { image: img23, title: " 23" },
  { image: img24, title: " 24" },
  { image: img25, title: " 25" },
  { image: img26, title: " 26" },
  { image: img27, title: " 27" },
  { image: img28, title: " 28" },
  { image: img29, title: " 29" },
  { image: img30, title: " 30" },
  { image: img31, title: " 31" },
  { image: img32, title: " 32" },
  { image: img33, title: " 33" },
  { image: img34, title: " 34" },
  { image: img35, title: " 35" },
  { image: img36, title: " 36" },
  { image: img37, title: " 37" },
  { image: img38, title: " 38" },
  { image: img39, title: " 39" },
  { image: img40, title: " 40" },
  { image: img41, title: " 41" },
  { image: img42, title: " 42" },
  { image: img43, title: " 43" },
  { image: img44, title: " 44" },
  { image: img45, title: " 45" },
  { image: img46, title: " 46" },
  { image: img47, title: " 47" },
  { image: img48, title: " 48" },
  { image: img49, title: " 49" },
  { image: img50, title: " 50" },
  { image: img51, title: " 51" },
  { image: img52, title: " 52" },
  { image: img53, title: " 53" },
  { image: img54, title: " 54" },
  { image: img55, title: " 55" },
  { image: img56, title: " 56" },
  { image: img57, title: " 57" },
  { image: img58, title: " 58" },
  { image: img59, title: " 59" },
  { image: img60, title: " 60" },
  { image: img61, title: " 61" },
  { image: img62, title: " 62" },
  { image: img63, title: " 63" },
  { image: img64, title: " 64" },
  { image: img65, title: " 65" },
];

export default function Gallery() {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [size, setSize] = useState("contain");
  const [position, setPosition] = useState("top");

  useEffect(() => {
    setInterval(() => {
      setSize("cover");
      setPosition("center");
    }, 1000);
  }, []);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            backgroundSize: size,
            backgroundPosition: position,
            backgroundPosition: "center",
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/bg2.jpg") +
              "')",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "40px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Gallery
          </div>
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "16px" : "22px",
            marginTop: "50px",
          }}
        >
          The BGS WORLD SCHOOL campus is a state-of-the-art educational hub
          equipped to deliver top-notch programs. It features advanced learning
          facilities, sports and cultural amenities, and a resource-rich
          library. The green and serene environment fosters academic focus and
          promotes a healthy, balanced student life.
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "16px" : "22px",
            marginBottom: "180px",
          }}
        >
          <Grid
            container
            spacing={state.auth.isMobile ? 0 : 2.5}
            style={{
              width: state.auth.isMobile ? "110%" : "80%",
              marginLeft: state.auth.isMobile ? "-17px" : "0px",
            }}
          >
            {images.map((gal, index) => (
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4} key={index}>
                <img
                  style={{
                    width: "100%",
                    objectFit: "cover",
                    margin: "10px",
                    height: "300px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                  src={gal.image} // Use the imported image directly
                  alt={gal.title}
                />
              </Grid>
            ))}
          </Grid>
        </div>

        <Explore />
        <Benchmark />

        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
